import { ServerDataSource } from "angular2-smart-table";
import { Observable } from "rxjs";
import { Book } from "./book";
import { Model } from "./common/.base.model";
import { EntityConfigTemplate } from "./common/entity-config.interface";

export interface Review extends Model {
  person?: string;
  content?: string;
  date: Date;
  book: Book;
}

export const ReviewConfig: EntityConfigTemplate = {
  meta: {},
  
} 

export abstract class ReviewData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Review[]>;
  abstract get(id: string): Observable<Review>;
  abstract update(review: Review): Observable<Review>;
  abstract create(review: Review): Observable<Review>;
  abstract delete(id: string): Observable<boolean>;
  
}